import { FC } from 'react';

import { Link, Text, VSpacing } from '@hh.ru/magritte-ui';

import styles from 'components/HelpModal/HelpModalContactPhone/HelpModalContactPhone.module.less';

export const HelpModalContactPhone: FC<{ label: string; phone: string }> = ({ label, phone }) => {
    return (
        <div className={styles.wrapper}>
            <Text typography="label-3-regular" style="secondary">
                {label}
            </Text>
            <VSpacing default={4} />
            <Link
                Element="a"
                style="neutral"
                typography="label-2-regular"
                href={`tel:${phone.replaceAll(/-|\(|\)|\s/g, '')}`}
            >
                {phone}
            </Link>
        </div>
    );
};
